/**
 * Referral code capture.
 *
 * Reads ?ref=CODE from the URL, stores it in a 30-day cookie.
 * On signup, the stored code is sent to the backend to link
 * the new user to their referrer.
 */

const COOKIE_NAME = "tf_ref";
const COOKIE_DAYS = 30;

/** Capture ref code from URL params and store in cookie. */
export function captureReferralCode(): void {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const code = params.get("ref");
  if (!code) return;

  // Don't overwrite an existing referral (first-touch attribution)
  if (getStoredReferralCode()) return;

  const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)};expires=${expires};path=/;SameSite=Lax`;
}

/** Retrieve stored referral code (or null). */
export function getStoredReferralCode(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/** Clear the referral cookie after it's been consumed by signup. */
export function clearReferralCode(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}
